const REQUIRED_VARS = [
  ['VITE_ENTRA_TENANT_ID', 'Entra (Azure AD) tenant id'],
  ['VITE_ENTRA_CLIENT_ID', 'SPA app registration (client) id'],
  ['VITE_API_SCOPE', 'API scope, e.g. api://<api-app-id>/access_as_user'],
  ['VITE_ENTRA_REDIRECT_URI', 'Optional — defaults to the current origin'],
  ['VITE_API_BASE_URL', 'Optional — empty in dev, API origin in prod'],
] as const;

/** Shown when Entra config is missing so the app cannot initialize MSAL. */
export function SetupNotice(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4 py-10">
      <div className="w-full max-w-xl rounded-2xl bg-white p-8 shadow-xl ring-1 ring-slate-200">
        <h1 className="text-xl font-semibold text-slate-900">Sign-in isn&apos;t configured yet</h1>
        <p className="mt-2 text-sm text-slate-500">
          Catalyst PSA uses Microsoft Entra ID for authentication. Create a{' '}
          <code className="rounded bg-slate-100 px-1 py-0.5 text-xs">.env</code> file in{' '}
          <code className="rounded bg-slate-100 px-1 py-0.5 text-xs">apps/frontend</code> with the
          following variables, then restart the dev server.
        </p>
        <dl className="mt-5 divide-y divide-slate-100">
          {REQUIRED_VARS.map(([name, description]) => (
            <div key={name} className="flex flex-col gap-0.5 py-2.5 sm:flex-row sm:justify-between">
              <dt className="font-mono text-sm text-brand-700">{name}</dt>
              <dd className="text-sm text-slate-500 sm:text-right">{description}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
